export default function LoadingCompanyDashboard() {
  return (
    <div className="container mx-auto animate-pulse">
      <section className="grid grid-cols-4 gap-8">
        {[1, 2, 3, 4].map((num) => (
          <div
            key={num}
            className="bg-neutralColor-light rounded-md p-8 flex flex-col justify-between gap-4"
          >
            <span className="bg-neutralColor-light w-1/2 h-3 rounded-md"></span>
            <span className="bg-neutralColor-light w-1/4 h-3 rounded-md"></span>
          </div>
        ))}
      </section>
      <section className="flex gap-8 mt-8">
        <div className="bg-neutralColor-light h-96 p-10 w-1/2 rounded-md"></div>
        <div className="bg-neutralColor-light h-96 p-10 w-1/2 rounded-md"></div>
      </section>
      <section className="mt-8 flex gap-8 h-full items-center">
        <div className="w-1/3 h-72 bg-neutralColor-light rounded-md"></div>
        <div className="w-2/3 h-72 bg-neutralColor-light rounded-md"></div>
      </section>
    </div>
  );
}
